import { useMemo, useState } from 'react';
import { works, categories } from '@/mocks/motionComics';

const tabs = ['全部', ...categories.map((c) => c.name)];

export default function FeaturedWorks() {
  const [active, setActive] = useState('全部');
  const [query, setQuery] = useState('');

  const list = useMemo(() => {
    return works.filter((w) => {
      const matchGenre = active === '全部' || w.genre === active;
      const q = query.trim().toLowerCase();
      const matchQuery = !q || w.title.toLowerCase().includes(q) || w.genre.includes(q);
      return matchGenre && matchQuery;
    });
  }, [active, query]);

  return (
    <section id="featured" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div id="search" className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-xl">
            <span className="text-xs font-medium tracking-widest text-primary-400">FEATURED WORKS</span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">热门全彩动态漫画</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-300">
              精挑细选的口碑之作，全彩有声、特效与配音同步上线。点开即播，画面流畅加载，追更一集不落。
            </p>
          </div>

          <label className="flex w-full max-w-sm items-center gap-2 rounded-md border border-background-300/60 bg-background-50 px-3.5 py-2.5 lg:w-auto">
            <i className="ri-search-line text-base text-foreground-400" aria-hidden="true"></i>
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索作品或分类…"
              className="w-full bg-transparent text-sm text-foreground-100 outline-none placeholder:text-foreground-500"
            />
          </label>
        </div>

        <div className="mt-8 flex flex-wrap gap-2" role="tablist" aria-label="作品分类筛选">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              role="tab"
              aria-selected={active === tab}
              onClick={() => setActive(tab)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === tab
                  ? 'bg-primary-500 text-background-950'
                  : 'border border-background-300/60 bg-background-50 text-foreground-300 hover:border-primary-400 hover:text-primary-400'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {list.length === 0 ? (
          <p className="mt-10 rounded-lg border border-background-300/50 bg-background-50 p-10 text-center text-sm text-foreground-400">
            没有找到匹配的作品，换个关键词试试吧。
          </p>
        ) : (
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
            {list.map((w) => (
              <a key={w.id} href={`#work-${w.id}`} className="card-lift group block overflow-hidden rounded-lg border border-background-300/50 bg-background-50">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={w.cover}
                    alt={`${w.title} 韩国动态漫画 全彩封面`}
                    title={`${w.title} 韩国动态漫画在线看`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <span className="absolute left-2.5 top-2.5 rounded-md bg-primary-500 px-2 py-0.5 text-[10px] font-semibold text-background-950">
                    {w.genre}
                  </span>
                  <span className="absolute right-2.5 top-2.5 rounded-md bg-black/50 px-2 py-0.5 text-[10px] text-accent-300">
                    <i className="ri-star-fill mr-0.5 text-accent-400" aria-hidden="true"></i>
                    {w.rating}
                  </span>
                  <span className="absolute inset-0 flex items-center justify-center bg-black/0 opacity-0 transition-opacity duration-300 group-hover:bg-black/40 group-hover:opacity-100">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-950">
                      <i className="ri-play-fill text-xl" aria-hidden="true"></i>
                    </span>
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="truncate text-sm font-semibold text-foreground-50 md:text-base">{w.title}</h3>
                  <div className="mt-2 flex flex-wrap gap-1">
                    {w.tags.map((t) => (
                      <span key={t} className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-900">
                        {t}
                      </span>
                    ))}
                  </div>
                  <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-400 md:text-xs">
                    <span>已更新 {w.episodes} 话</span>
                    <span className="text-accent-400">{w.views} 播放</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}